export interface SampleDTO {
    id: number;
    sampleCode: string;
    methode: string;
    sampleType: string;
    methodeId:number;
    collectedById: string;
    collectedByName: string;
    collectionDate: string;
    updateDate: string;
    dateReception: string;
    qtePre: number;
    priorite: number;
    observation: string;
    storageConditions: string;
    volume: string;
    temperature: string; // ancien champ
    temperaturePrelevement?: string; // nouveau
    temperatureReception?: string; // nouveau
    validated: boolean;
    comments?: string;
    location?: string;
    creationDate?: string;
    socialReason: string;
    matriceName?: string;
    nameCreatedBy?: string;
    status?: number;
    idCreatedBy: number | null;
    clientId: number | null;
    matriceId: number | null;
    codeAT?: string;
    idAT?: number;
    parametreId: number | null;
    terrainId: number;
    terrainName: string;
    dureeRespecte: boolean;
    batchId: number;
    note: string;
    sampStatus: string;

    // Nouveaux champs
    dateProduction?: string;
    dateLimiteConsommation?: string;
    referenceInterne?: string;
    visa?: string;
}

export interface SampleAffectationRequest {
    userId: number;
    sampleIds: number[];
}

export interface CreatePrelevementDTO {
  clientId?: number;
  batchId?: number;
  terrainId?: number;
  collectedById?: number;
  collectionDate?: string;
  qtePre?: number;
  temperaturePrelevement?: string;
  dateProduction?: string;
  dateLimiteConsommation?: string;
}

// src/app/models/prelevement-sample.dto.ts
export interface PrelevementSampleDto {
  typeSampleName: string; // <- correspond au mat-select
  clientId: number;
  batchId: number;
  batchReference?: string | null;
  terrainId: number;
  departmentIds:number[],
  collectionDate?: string; // format ISO : 'yyyy-MM-ddTHH:mm'
  collectedById: number;
  qtePre: string;
  temperaturePrelevement?: string;
  dateProduction?: string; // format 'yyyy-MM-dd'
  dateLimiteConsommation?: string; 
  typeAnalyseId: number;
  matriceId: number;
  designation?: string;        // description / Frozen medium juice concentrate
  scelle?: boolean;            // Oui / Non
  conditionnement?: string;    // Pot stérile / Sachet / Flacon
  priorite?: string;
  accredited?: boolean; 
  preleveParClient?: boolean; 
}
export interface PrelevementSampleView {
  id: number;
  sampleCode: string;
  typeSampleName: string;
  clientName: string;
  batchName: string;
  batchId?: number;        
  terrainVarPlante: string;
  collectedByUsername: string;
  qtePre: number;
  typeAnalyseId: number;
  departmentIds:number[],
  matriceId: number;
  collectionDate: string;
  temperaturePrelevement?: string;
  dateProduction?: string; // format 'yyyy-MM-dd'
  dateLimiteConsommation?: string; // format 'yyyy-MM-dd'
}

export interface ReceptionSampleDto {
  id: number;
  typeAnalyseId: number;
  matriceId: number;
  temperatureReception: string;
  referenceInterne: string;
  sampleCondition: string; // obligatoire
  storageConditions: string;
  dateReception: string;
  remarques: string;

}


  export interface ValidateSampleDTO {
    id: number; // id de l'échantillon à valider
    accept: boolean; // true = validé, false = rejeté
    comments?: string; // optionnel
  }
      
// src/app/_models/sample-status.enum.ts
export enum SampleStatus {
    PRELEVEMENT = 'PRELEVEMENT',
    RECEPTION = 'RECEPTION',
    VALIDE = 'VALIDE',
    REJETE = 'REJETE'
  }
  